import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Coverage } from './../../models/coverages/coverage.model';
import { PolicyFlightOverride } from '@bhtp-client-web/component';

@Component({
    selector: 'coverage-display-list',
    template: require('./coverage-display-list.component.html')
})
export class CoverageDisplayListComponent {
    @Input() public standardCoverages: Array<Coverage>;
    @Input() public extraCoverages: Array<Coverage>;
    @Input() public optionalCoverages: Array<Coverage>;
    @Input() public mode: string;
    @Input() public flightReminderPolicy: PolicyFlightOverride;
    @Output() public directToEditEmitter: EventEmitter<string> = new EventEmitter<string>();

    private buttonText: string = `ADD CUSTOMER'S FLIGHTS`;
    private message: string = `If flight information is provided prior to the departure date, flights can be tracked and claims can be automatically created. Insuring more than 4 flights will incur additional premium charges.`;
    private messageHeading: string = `Don't forget to add flights!`;

    public showTwoColumns(): boolean {
        return this.mode === 'receipt';
    }

    public showOptionalCoverages(): boolean {
        return this.optionalCoverages && this.optionalCoverages.length > 0 && this.mode !== 'quote';
    }

    public get showFlightReminder(): boolean {
        if (this.flightReminderPolicy && this.flightReminderPolicy.futureFlightsExpected && this.flightReminderPolicy.flightCount === 0) {
            return true;
        }

        return false;
    }

    private directToEdit(policyNumber: string): void {
        this.directToEditEmitter.emit(policyNumber);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/coverages/coverage-display-list.component.ts